// Spanish translations
export const translationsES = {
  nav: {
    home: "Inicio",
    icfPlans: "Planos ICF Multifamiliares",
    shop: "Tienda",
    sixPlex: "6-Plex ICF",
    eightPlex: "8-Plex ICF",
    twelvePlex: "12-Plex ICF",
    townhomes: "Townhomes ICF",
    investors: "Inversores y Prestamistas",
    process: "Del Plano al Permiso",
    about: "Nosotros",
    team: "Nuestro Equipo",
    contact: "Contacto",
    blog: "Blog"
  },
  hero: {
    headline: "Diseños de multiplex optimizados para maximizar la rentabilidad de los promotores inmobiliarios",
    subheadline: "Ingresos de alquiler maximizados. Costos de construcción optimizados. Rendimiento garantizado.",
    viewPlans: "Ver planos",
    downloadGuide: "Descargar guía para inversores"
  },
  whyUs: {
    title: "¿Por qué elegir Plexterra?",
    point1Title: "Especialistas ICF multifamiliar",
    point1Text: "Experiencia reconocida en diseño de multiplex con encofrados aislantes de hormigón.",
    point2Title: "Planos listos para adaptar",
    point2Text: "Conceptos arquitectónicos optimizados, adaptables a su terreno y jurisdicción.",
    point3Title: "Cumplimiento SCHL",
    point3Text: "Planos que cumplen con los criterios de alto rendimiento energético.",
    point4Title: "Visión internacional",
    point4Text: "Diseñados para los mercados canadiense, estadounidense e internacional."
  },
  icf: {
    title: "Tecnología ICF: construido para durar",
    benefit1Title: "Durabilidad 100+ años",
    benefit1Text: "Estructura de hormigón armado resistente a la intemperie y al fuego.",
    benefit2Title: "Eficiencia energética",
    benefit2Text: "Aislamiento R-22 a R-50, ahorros de hasta 50% en energía.",
    benefit3Title: "Reducción de riesgos",
    benefit3Text: "Menos siniestros, primas de seguro reducidas hasta 25%.",
    benefit4Title: "Valor ESG",
    benefit4Text: "Huella de carbono reducida, cumplimiento con estándares sostenibles.",
    learnMore: "Más información sobre ICF"
  },
  plans: {
    title: "Planos multifamiliares disponibles",
    subtitle: "Conceptos optimizados para maximizar el rendimiento por pie cuadrado",
    viewPlan: "Ver plano",
    idealFor: "Ideal para",
    urbanLots: "terrenos urbanos",
    midSize: "proyectos medianos",
    largeScale: "proyectos a gran escala",
    rowHouses: "casas adosadas"
  },
  esg: {
    title: "Sostenibilidad y Financiamiento: La Ventaja ESG",
    text: "Nuestros planos ICF están diseñados para cumplir con los crecientes requisitos de sostenibilidad. El cumplimiento SCHL y las características ESG facilitan:",
    point1: "Acceso a financiamiento bancario",
    point2: "Tasas preferenciales para proyectos verdes",
    point3: "Elegibilidad para subsidios gubernamentales",
    point4: "Valorización a largo plazo de los activos",
    viewSheet: "Ver ficha para inversores"
  },
  cta: {
    title: "¿Listo para invertir en el inmobiliario del mañana?",
    card1Title: "Ver planos",
    card1Text: "Explore nuestros conceptos 6-plex, 8-plex y 12-plex.",
    card1Button: "Tienda",
    card2Title: "Guía para inversores",
    card2Text: "Descargue nuestra documentación completa.",
    card2Button: "Descargar (PDF)",
    card3Title: "Contáctenos",
    card3Text: "Hablemos de su proyecto de inversión.",
    card3Button: "Contacto"
  },
  icfPage: {
    h1: "Planos multifamiliares ICF para inversores",
    subtitle: "Conceptos arquitectónicos de grado institucional, optimizados para el rendimiento financiero y la sostenibilidad.",
    whatIsIcf: "¿Qué es ICF?",
    icfExplanation: "Los Encofrados de Concreto Aislante (ICF) son un sistema de construcción donde los bloques de poliestireno expandido sirven como encofrado permanente para el hormigón armado. Esta tecnología ofrece un aislamiento térmico excepcional y una durabilidad inigualable.",
    whyInvestorsTitle: "Por qué los inversores eligen ICF",
    reducedCosts: "Costos operativos reducidos",
    reducedCostsPoints: ["40-50% de ahorro en calefacción/refrigeración", "Menos mantenimiento estructural", "Vida útil de 100+ años"],
    riskReduction: "Reducción de riesgos",
    riskReductionPoints: ["Resistencia al fuego de 4 horas (vs 1 hora madera)", "Resistencia a condiciones climáticas extremas", "Primas de seguro reducidas hasta 25%"],
    betterFinancing: "Mejor financiamiento",
    betterFinancingPoints: ["Cumplimiento ESG buscado por prestamistas", "Elegibilidad para programas verdes", "Mayor valor de reventa"],
    rentalStability: "Estabilidad de alquiler",
    rentalStabilityPoints: ["Confort acústico superior", "Facturas de energía reducidas", "Imagen moderna y sostenible"],
    comparisonTitle: "ICF vs Estructura de madera",
    criteria: "Criterios",
    woodFrame: "Estructura de madera",
    lifespan: "Vida útil",
    years: "años",
    insulation: "Aislamiento (valor R)",
    fireResistance: "Resistencia al fuego",
    hours: "horas",
    hour: "hora",
    energyCosts: "Costos energéticos",
    baseline: "Referencia",
    maintenance: "Mantenimiento estructural",
    minimal: "Mínimo",
    moderate: "Moderado",
    insurancePremium: "Prima de seguro",
    soundproofing: "Insonorización",
    excellent: "Excelente",
    poor: "Pobre",
    resaleValue: "Valor de reventa",
    higher: "Superior",
    standard: "Estándar",
    availableFormats: "Formatos disponibles",
    importantNotice: "Aviso importante",
    noticeText: "Nuestros planos son conceptos arquitectónicos que requieren adaptación por un arquitecto local para: cumplimiento con el código de construcción de su jurisdicción, adaptación a las características de su terreno, y certificación por un ingeniero autorizado. Plexterra no es un contratista general. Diseñamos planos que usted proporciona a los profesionales de su elección."
  },
  investors: {
    h1: "Para Inversores y Prestamistas",
    subtitle: "Documentación de grado bancario para una toma de decisiones informada.",
    whyBankable: "Por qué estos proyectos son financiables",
    icfAdvantages: "Ventajas estructurales ICF",
    icfPoints: ["Durabilidad 100+ años reduce el riesgo a largo plazo", "Resistencia al fuego e intemperie minimiza siniestros", "Primas de seguro reducidas mejoran el NOI"],
    financialPerformance: "Rendimiento financiero",
    financialPoints: ["40-50% de ahorro energético aumenta el NOI", "Costos de mantenimiento reducidos en el ciclo de vida", "Mayor retención de inquilinos debido al confort"],
    esgTitle: "ESG y Sostenibilidad",
    esgPoints: ["Huella de carbono reducida alineada con mandatos ESG", "Cumplimiento SCHL para financiamiento verde", "Protección contra regulaciones energéticas futuras"],
    rentalTitle: "Estabilidad de alquiler",
    rentalPoints: ["Aislamiento acústico superior = inquilinos satisfechos", "Facturas de servicios reducidas = alquileres competitivos", "Construcción moderna = posicionamiento premium"],
    keyMetrics: "Métricas clave",
    downloadPack: "Descargar pack para inversores"
  },
  process: {
    h1: "Del Plano al Permiso",
    subtitle: "Un proceso simplificado para concretar su proyecto de inversión.",
    step1Title: "Selección del plano",
    step1Text: "Elija entre nuestros conceptos ICF 6-plex, 8-plex, 12-plex o townhomes según sus objetivos de inversión.",
    step2Title: "Compra del concepto",
    step2Text: "Compre el paquete completo incluyendo planos arquitectónicos, documentación técnica y guía de adaptación.",
    step3Title: "Adaptación local",
    step3Text: "Su arquitecto adapta el concepto a su terreno y a los requisitos del código de construcción local.",
    step4Title: "Certificación",
    step4Text: "Un ingeniero autorizado certifica los planos estructurales adaptados a su jurisdicción.",
    step5Title: "Permiso de construcción",
    step5Text: "Presente los planos certificados a su municipalidad para obtener el permiso de construcción.",
    step6Title: "Construcción",
    step6Text: "Seleccione un contratista calificado en ICF e inicie la construcción de su proyecto.",
    whatIncluded: "Qué incluye su compra",
    includedItems: [
      "Planos arquitectónicos detallados (PDF + CAD)",
      "Especificaciones técnicas ICF",
      "Guía de adaptación para arquitecto",
      "Ficha técnica para inversores",
      "Estimaciones de costos indicativas",
      "Soporte por email (30 días)"
    ],
    startProject: "Iniciar su proyecto"
  },
  about: {
    h1: "Acerca de Plexterra",
    subtitle: "Su socio de confianza en diseño multifamiliar ICF.",
    missionTitle: "Nuestra Misión",
    missionText: "Plexterra se dedica al diseño de planos multifamiliares ICF de grado institucional. Nuestra misión es proporcionar a los inversores inmobiliarios conceptos arquitectónicos optimizados para el rendimiento financiero y la sostenibilidad ambiental.",
    expertiseTitle: "Nuestra Experiencia",
    expertiseText: "Especializados en encofrados de concreto aislante (ICF), combinamos innovación constructiva y rigor financiero para crear planos que cumplen con los requisitos de los inversores y prestamistas más exigentes.",
    valuesTitle: "Nuestros Valores",
    value1Title: "Excelencia",
    value1Text: "Planos de grado institucional, presentables ante cualquier comité de crédito bancario.",
    value2Title: "Innovación",
    value2Text: "Tecnología ICF de vanguardia para máxima durabilidad y eficiencia.",
    value3Title: "Transparencia",
    value3Text: "Documentación completa y realista, sin promesas exageradas.",
    value4Title: "Sostenibilidad",
    value4Text: "Compromiso con estándares ESG y construcción responsable.",
    marketsTitle: "Nuestros Mercados",
    marketsText: "Nuestros planos están diseñados para ser adaptables a los mercados canadiense, estadounidense e internacional, con especial atención a los códigos de construcción y requisitos de financiamiento de cada jurisdicción."
  },
  contact: {
    h1: "Contáctenos",
    subtitle: "Hablemos de su proyecto de inversión multifamiliar.",
    formTitle: "Envíenos un mensaje",
    name: "Nombre completo",
    email: "Correo electrónico",
    phone: "Teléfono (opcional)",
    company: "Empresa (opcional)",
    projectType: "Tipo de proyecto",
    selectProject: "Seleccione un tipo de proyecto",
    project6plex: "6-Plex ICF",
    project8plex: "8-Plex ICF",
    project12plex: "12-Plex ICF",
    projectTownhomes: "Townhomes ICF",
    projectOther: "Otro",
    message: "Mensaje",
    messagePlaceholder: "Describa su proyecto de inversión...",
    submit: "Enviar mensaje",
    sending: "Enviando...",
    successTitle: "¡Mensaje enviado!",
    successText: "Le responderemos en 24-48 horas.",
    infoTitle: "Información",
    responseTime: "Tiempo de respuesta: 24-48 horas",
    languages: "Idiomas: Français, English, Español",
    markets: "Mercados: Canadá, USA, Internacional"
  },
  product: {
    from: "Desde",
    addToCart: "Ordenar este plano",
    features: "Características",
    specifications: "Especificaciones técnicas",
    units: "Unidades",
    floors: "Pisos",
    sqft: "Superficie",
    fireRating: "Resistencia al fuego",
    rValue: "Valor R",
    included: "Qué incluye",
    includedItems: [
      "Planos arquitectónicos detallados (PDF + CAD)",
      "Especificaciones técnicas ICF",
      "Guía de adaptación para arquitecto",
      "Ficha técnica para inversores",
      "Soporte por email (30 días)"
    ],
    disclaimer: "Aviso: Estos planos son conceptos arquitectónicos que requieren adaptación por un arquitecto local autorizado."
  },
  footer: {
    tagline: "Multiplex Designs for Developers",
    quickLinks: "Enlaces rápidos",
    legal: "Legal",
    legalNotice: "Aviso legal",
    privacyPolicy: "Política de privacidad",
    termsOfSale: "Condiciones de venta",
    newsletter: "Boletín",
    newsletterText: "Reciba nuestras últimas noticias y ofertas.",
    subscribe: "Suscribirse",
    subscribing: "Suscribiendo...",
    subscribed: "¡Suscrito!",
    emailPlaceholder: "Su correo electrónico",
    rights: "Todos los derechos reservados."
  },
  blog: {
    title: "Blog",
    subtitle: "Artículos y guías sobre inversión inmobiliaria ICF",
    readMore: "Leer más",
    backToBlog: "Volver al blog",
    publishedOn: "Publicado el",
    category: "Categoría",
    relatedArticles: "Artículos relacionados"
  }
};
